import http from 'hub-http/clients/apiClient';
import { registerMutation, registerQuery } from 'data-fetching-client';
const DASHBOARD_BLUEPRINTS_URL = 'reporting-discovery/v1/dashboard-blueprint';
export const CREATE_DASHBOARD_BLUEPRINT_FIELD_NAME = 'createDashboardBlueprint';
export const UPDATE_DASHBOARD_BLUEPRINT_FIELD_NAME = 'updateDashboardBlueprint';
export const IMPORT_DASHBOARD_BLUEPRINT_FIELD_NAME = 'importDashboardBlueprint';
export const DASHBOARD_BLUEPRINT_BY_DASHBOARD_FIELD_NAME = 'getDashboardBlueprintByDashboard';
const createDashboardBlueprint = dashboardId => http.post(DASHBOARD_BLUEPRINTS_URL, {
  data: {
    dashboardId
  }
});
const updateDashboardBlueprint = dashboardId => http.put(`${DASHBOARD_BLUEPRINTS_URL}/sync`, {
  data: {
    dashboardId
  }
});
const importDashboardBlueprint = uuid => http.post(`${DASHBOARD_BLUEPRINTS_URL}/import`, {
  data: {
    uuid
  }
});
export const deleteDashboardBlueprint = blueprintId => http.delete(`${DASHBOARD_BLUEPRINTS_URL}/${blueprintId}`);
export const CREATE_DASHBOARD_BLUEPRINT = registerMutation({
  fieldName: CREATE_DASHBOARD_BLUEPRINT_FIELD_NAME,
  args: ['dashboardId'],
  fetcher({
    dashboardId
  }) {
    return createDashboardBlueprint(dashboardId);
  }
});
export const UPDATE_DASHBOARD_BLUEPRINT = registerMutation({
  fieldName: UPDATE_DASHBOARD_BLUEPRINT_FIELD_NAME,
  args: ['dashboardId'],
  fetcher({
    dashboardId
  }) {
    return updateDashboardBlueprint(dashboardId);
  }
});
export const IMPORT_DASHBOARD_BLUEPRINT = registerMutation({
  fieldName: IMPORT_DASHBOARD_BLUEPRINT_FIELD_NAME,
  args: ['uuid'],
  fetcher({
    uuid
  }) {
    return importDashboardBlueprint(uuid);
  }
});
const fetchBlueprintByDashboardId = dashboardId => http.get(`${DASHBOARD_BLUEPRINTS_URL}/by-dashboard-id/${dashboardId}`);
export const GET_DASHBOARD_BLUEPRINT_BY_DASHBOARD = registerQuery({
  fieldName: DASHBOARD_BLUEPRINT_BY_DASHBOARD_FIELD_NAME,
  args: ['dashboardId'],
  fetcher({
    dashboardId
  }) {
    return fetchBlueprintByDashboardId(dashboardId);
  }
});